module.exports = __webpack_public_path__ + "static/favicon-ca5a516196bbef42676f4de2fffcba36.ico";